import { Table } from 'react-bootstrap';
import styled, { createGlobalStyle } from "styled-components";


export const HeaderRowWrapper = styled.tr`
    & > th {
        background-color: #BBB;
        color: black;
        padding: 3px !important;
    }
`;

export const RowWrapper = styled.tr`
    & > td:nth-child(1) {
        padding-left: 0px !important;
        padding-right: 0px !important;
        width: 30px;
        text-align: center;
    }

    & > td {
        padding: 3px !important;
        vertical-align: middle !important;
        color: #003;
    }

    & > td > a:link,
    & > td > a:visited {
        color: black;
        text-decoration: underline;
    }

    .recipient-voucher-donor-pending {
        background-color: #ddd;
    }
    
    .recipient-donation-before-vh-donation {
        background-color: #FF954D;
    }

    .recipient-donation-vh-donor-needs-match {
        background-color: #EF0909;
    }

    .recipient-donation-vh-donor-needs-match > a {
        color: white !important;
    }

    @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
    }

    .spinner {
    border: 2px solid rgb(255, 255, 255);
    border-left-color: #000;
    border-radius: 50%;
    width: 11px;
    height: 11px;
    animation: spin 0.8s linear infinite;
    display: inline-block;
    margin-right: 6px;
    vertical-align: middle; /* Aligns with the middle of the text line */
}

`;

export const TooltipGlobalStyle = createGlobalStyle`
    .ph-toggle-tooltip .tooltip-inner,
    .ph-col-tooltip .tooltip-inner {
        background-color: white;
        color: #000;
        border: 1px solid #ccc;
        box-shadow: 0 2px 6px rgba(0,0,0,0.15);
        max-width: 500px;
        font-size: 14px;
        font-family: inherit;
        font-weight: normal;
        padding: 10px 12px;
        border-radius: 6px;
    }

    .ph-toggle-tooltip .tooltip-inner {
        min-width: 280px;
    }

    .ph-toggle-tooltip.tooltip.bottom .tooltip-arrow,
    .ph-col-tooltip.tooltip.bottom .tooltip-arrow {
        border-bottom-color: #ccc;
    }

    .ph-toggle-tooltip.tooltip.in,
    .ph-col-tooltip.tooltip.in {
        opacity: 1;
    }
`;


export const PlaceholderTable = styled(Table)`
    background-color: white;
    margin-bottom: 0px;
    width: 120%; /* Increase width by 20% */

    & > tbody > tr {
        cursor: default;
    }

    & > tbody > tr > td {
        padding: 2px;
        text-align: center;
        // font-size: 16px;
    }

    .ph-sticky-header {
        box-shadow: 0 2px 4px rgba(0,0,0,0.15);
    }

    border-collapse: separate;
    border-spacing: 0;

    td.ph-header-group {
        width: 50%;
    }

    td.ph-header-fvt {
        width: 12%;
    }

    td.ph-header-ncs {
        width: 13%;
    }

    td.ph-header-wdr {
        width: 13%;
    }

    td.ph-header-abwl {
        width: 10%;
    }

    td.ph-header-a2 {
        width: 10%;
    }

    td.ph-header-ap {
        width: 10%;
    }

    td.ph-header-dist {
        width: 13%;
    }

    & > tbody > tr.ph-row:hover > td {
        box-shadow: inset 0 1.5px 0 0 #2e6da4, inset 0 -1.5px 0 0 #2e6da4;
    }

    & > tbody > tr.ph-row:hover > td:first-child {
        box-shadow: inset 1.5px 1.5px 0 0 #2e6da4, inset 0 -1.5px 0 0 #2e6da4;
    }

    & > tbody > tr.ph-row:hover > td:last-child {
        box-shadow: inset -1.5px 1.5px 0 0 #2e6da4, inset 0 -1.5px 0 0 #2e6da4;
    }
 
    .high-decline-ratio {
        background-color: lightgrey;
    }

    .utilize-a2-b-patients {
        background-color: white;
    }

    .light-green {
        background-color: lightgreen;
    }
`;


export const TableWrapper = styled(Table)`
    margin-bottom: 0px;
    
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
        font-size: 12px;
    }
`;

export const SsdTableWrapper = styled(Table)`
    margin-bottom: 10px;

    & > thead > tr > th {
        text-align: center;
    }

    & > tbody > tr > td {
        text-align: center;
    }
`;